// extracted by mini-css-extract-plugin
export var animationContainer = "_fj-0";
export var asteriskIcon = "_fj-8";
export var conversationLeftSection = "_fj-4";
export var conversationListItem = "_fj-3";
export var conversationMiddleSection = "_fj-5";
export var conversationRightSection = "_fj-6";
export var detailsContent = "_fj-1";
export var listContainer = "_fj-7";
export var modalContent = "_fj-2";